import { Component, inject, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentGroupKind } from '@core/tellent-types';
import {
  AvatarComponent,
  ButtonComponent,
  ButtonLoadingDirective,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  HeadingComponent,
} from '@core/user-interface-legacy';

type DialogData = {
  member: { fullName: string; avatarThumbUrl: string; email: string };
  groupName: string;
  groupKind: TellentGroupKind;
  saveAction: () => Promise<{ isSuccess: boolean }>;
};

@Component({
  selector: 'remove-team-member-from-group-confirmation-dialog',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    TranslatePipe,
    AvatarComponent,
    HeadingComponent,
    ButtonLoadingDirective,
  ],
  templateUrl: './remove-team-member-from-group-confirmation-dialog.component.html',
  styleUrl: './remove-team-member-from-group-confirmation-dialog.component.less',
})
export class RemoveTeamMemberFromGroupConfirmationDialogComponent implements DialogComponentI<
  DialogData,
  null | boolean
> {
  private readonly dialog = inject(DialogRef);
  protected readonly translationKeys = {
    [TellentGroupKind.Group]: {
      header: 'tlc.remove_from_group_dialog.header',
      desc1: 'tlc.remove_from_group_dialog.desc_1',
      desc2: 'tlc.remove_from_group_dialog.desc_2',
      confirm: 'tlc.remove_from_group_dialog.confirm',
    },
    [TellentGroupKind.Department]: {
      header: 'tlc.remove_from_department_dialog.header',
      desc1: 'tlc.remove_from_department_dialog.desc_1',
      desc2: 'tlc.remove_from_department_dialog.desc_2',
      confirm: 'tlc.remove_from_department_dialog.confirm',
    },
  };
  protected member: { fullName: string; avatarThumbUrl: string; email: string };
  protected groupName: string;
  protected groupKind: TellentGroupKind;
  protected saveAction: () => Promise<{ isSuccess: boolean }>;
  protected loading = signal(false);

  public setDialogData(data: DialogData): void {
    this.member = data.member;
    this.groupName = data.groupName;
    this.groupKind = data.groupKind;
    this.saveAction = data.saveAction;
  }

  protected close() {
    this.dialog.close();
  }

  protected async confirm(): Promise<void> {
    this.loading.set(true);
    const result = await this.saveAction();
    if (result.isSuccess) {
      this.close();
    }
    this.loading.set(false);
  }
}
